export const AppPagePaths = {
    fallback: "/",
    admin: "/admin",
    regalLive: "/regal-live",
    regalLiveAi: "/regal-live-ai",
    aiAgents: "/ai-agents",
    convoIntel: "/intelligence",
    orchestration: "/orchestration",
    audience: "/audience",
    liveOps: "/live-ops",
    agentDesktop: "/agent",
    copilot: "/copilot",
    reporting: "/reporting",
    settings: "/settings",

    // TODO: Talk to prod about how we want to router to journey users
    journeysUsers: "/journeys-users",
} as const satisfies Record<string, `/${string}`>;

export type AppPageRouteTypes = (typeof AppPagePaths)[keyof typeof AppPagePaths];

export const LegacyPagePaths = {
    agents: "/agents",
    phoneNumbers: "/phone-numbers",
    transcripts: "/transcripts",
    tasks: "/tasks",
    recentTasks: "/recent-tasks",
    campaigns: "/campaigns",
    journeys: "/journeys",
    segment: "/segments",
    recentActivity: "/recent-activity",
    queues: "/queues",
};
